<template>
    <div class="backoffice-section">
        <div class="backoffice-content">
            <h2 class="backoffice-title fuente-posm">
                Portal de Backoffice para consultas
            </h2>
            <p class="backoffice-text fuente-nova">
                Mantén el control total de tu facturación.
                <br><br>
                Consulta el estatus de cada factura emitida, identifica fácilmente los tickets que aún no se han facturado y genera facturas abiertas cuando un cliente lo solicite.
                <br><br>
                Sin cambiar de sistema, sin buscar en diferentes reportes.
            </p>
        </div>
        <div class="backoffice-image">
            <img :src="a64" alt="Backoffice">
        </div>
    </div>
</template>

<script>
export default {
    name: 'BackofficeNew',
    data() {
        return {
            a64: require('@/assets/images/a64.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.backoffice-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.backoffice-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.backoffice-image img {
    width: 500px;
    height: auto;
}

.backoffice-content {
    flex: 1;
    max-width: 700px;
    order: 1;
}

.backoffice-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.backoffice-text {
    color: var(--color-3);
    font-size: 25px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .backoffice-title {
        font-size: 60px;
    }

    .backoffice-text {
        font-size: 22px;
    }

    .backoffice-image img {
        width: 400px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .backoffice-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .backoffice-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .backoffice-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .backoffice-image img {
        width: 100%;
        max-width: 350px;
    }

    .backoffice-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .backoffice-text {
        font-size: 15px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
